export { default as ResponsiveBullet } from './dist/ResponsiveBullet.js';
